import './InputDate.scss';
import TextField from '@mui/material/TextField';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import type { Dayjs } from 'dayjs';
import { dateFormatData } from 'features/dates/date-helpers';
import { Field } from 'formik';
import type { FixMeLater } from 'types/FixMeLaterType';

interface InputDateProps {
	name: string;
	label: string;
	minDate?: Dayjs;
	maxDate?: Dayjs;
	disabled?: boolean;
	disablePast?: boolean;
	onValueChange?: (date: string | null) => void;
	validate?: (value: FixMeLater) => string | undefined;
	ariaLabel?: string;
}

export const InputDate = ({
	name,
	disablePast,
	disabled = false,
	minDate,
	maxDate,
	onValueChange,
	validate,
	ariaLabel,
	...props
}: InputDateProps) => {
	return (
		<div className='date-container form-row__item'>
			<Field name={name} validate={validate}>
				{({ form, field, meta }: FixMeLater) => {
					const { setFieldValue } = form;
					return (
						<div>
							<DatePicker
								{...field}
								{...props}
								name={name}
								disabled={disabled}
								disablePast={disablePast}
								onChange={(val: Dayjs) => {
									const formattedVal = val?.format(dateFormatData) || null;
									setFieldValue(name, formattedVal);
									onValueChange?.(formattedVal);
								}}
								minDate={minDate}
								maxDate={maxDate}
								renderInput={(params) => (
									<TextField
										helperText={meta.touched && meta.error}
										margin='normal'
										{...params}
										{...props}
										name={name}
										error={meta.touched && !!meta.error}
										inputProps={{
											...params.inputProps,
											'aria-label': ariaLabel,
										}}
									/>
								)}
							/>
						</div>
					);
				}}
			</Field>
		</div>
	);
};
